var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-pagination',{class:false ? 'pagination__day' : 'pagination__night',attrs:{"page-sizes":[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000],"page-size":1000,"layout":"sizes, prev, pager, next","total":10000}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }